let React =            require("react");
let MasterPage =       require("./../../pages/generic/MasterPage.jsx");
let DataListPage =     require("./../../pages/generic/DataListPage.jsx");
let EmptyPackageCard = require("./../empty/EmptyPackageCard.jsx");
let PackageCard =      require("./../cards/PackageCard.jsx");

class ExplorePackages extends React.Component {

    constructor() {
        super()
    }
    
    componentDidMount() {
        document.title = `Explore/packages | library.io`;
        googleGA("send", "event", `explore/packages`, "pageview");
    }

    componentWillUnmount(){
        if(this.props.clearValueSearch){
            this.props.clearValueSearch();
        }
    }

    render() {
        //this config is necessary because search pages reuse the explorer view, by default the config is for explore pages, that config could be changed from the search page
        let {hasSearching = false} = this.props

        return  <DataListPage
                    {...this.props}
                    page="explore"
                    endpoint="/explore/packages"
                    displayName={`Packages`}
                    showNumElements={true}
                    urlName="packages"
                    cssCardTag="package"
                    defaultLayout="grid"
                    hasSearching={hasSearching}
                    loginRequired={false}
                    canSwitchLayout
                    resetViewAfterNewUpload
                    uploadContentIsAboveTitle
                    EmptyCard={EmptyPackageCard}
                    CardType={PackageCard}
                    hasSelectSort={true}
                    isPublicFacing={true}
                    switchThumbnail={true}
                    hasGridLayoutSwitch={false}
                    showLoadingPlaceholder={false}
                />
    }
}

module.exports = ExplorePackages;
